import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import { DescriptionTooltip } from '../../components/DescriptionTooltip';
import { getDeveloperRatingDescriptionById } from '../../selectors';
import { IApplicationState } from '../../types/redux';

interface IRatingDescriptionProps {
  ratingId: number;
}

export function RatingDescription({ ratingId }: IRatingDescriptionProps) {
  const description = useSelector((state: IApplicationState) => getDeveloperRatingDescriptionById(state, ratingId));

  if (!description) {
    return null;
  }

  return description.popupText ? (
    <DescriptionTooltip text={description.text} popupText={description.popupText} />
  ) : (
    <ArticleParagraph2>{description.text}</ArticleParagraph2>
  );
}
